import React from 'react'
import Box from 'transfix-ui/core/Box'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { useBreakpoint, useUserDetails } from 'utils/hooks'
import { Accounting } from './Cards/Accounting'
import { CarrierStatus } from './Cards/CarrierStatus'
import { CommoditiesCovered } from './Cards/CommoditiesCovered'
import { CompanyOverview } from './Cards/CompanyOverview'
import { Documents } from './Cards/Documents'
import { Insurance } from './Cards/Insurance'
import { Notes } from './Cards/Notes'
import { ScheduledVins } from './Cards/ScheduledVins'
import { StatsSummary } from './Cards/StatsSummary'
import { Vins } from './Cards/Vins'
import { DeprecatedComplianceTab } from './DeprecatedComplianceTab'
import UpdateMarketplaceDataButton from './UpdateMarketplaceDataButton'

const sidebarWithPadding = 350 + 112

export const Compliance = () => {
  const isHighwayMilestoneFourComplianceTabEnabled = useFeatureFlag(
    'highwayMilestoneFourComplianceTab'
  )
  const isSyncHighwayWithMarketplaceEnabled = useFeatureFlag('syncHighwayWithMarketplace')

  const { isTablet } = useBreakpoint()
  const { userPermissions } = useUserDetails()
  const { canManageCarrierVin } = userPermissions || {}

  const maxWidthMain = isTablet ? 'calc(100vw - 32px)' : `calc(100vw - ${sidebarWithPadding}px)`
  const maxWidthSidebar = isTablet ? 'calc(100vw - 32px)' : '350px'

  return (
    <div data-test='compliance-tab-content'>
      {isHighwayMilestoneFourComplianceTabEnabled ? (
        <Box
          display='grid'
          gap='1rem'
          gridTemplateColumns={isTablet ? '1fr' : '350px 1fr'}
          alignItems='start'
          mt='1rem'>
          <Box display='grid' gap='1rem'>
            <Box overflow='auto' maxWidth={maxWidthSidebar}>
              <CarrierStatus />
            </Box>
            <StatsSummary />
            <Box overflow='auto' maxWidth={maxWidthSidebar}>
              <Documents />
            </Box>
            <Box overflow='auto' maxWidth={maxWidthSidebar}>
              <Notes />
            </Box>
            {isSyncHighwayWithMarketplaceEnabled && <UpdateMarketplaceDataButton />}
          </Box>
          <Box display='grid' gap='1rem'>
            <CompanyOverview />
            <Box maxWidth={maxWidthMain}>
              <Insurance />
            </Box>
            {canManageCarrierVin && (
              <>
                <Vins />
                <ScheduledVins />
              </>
            )}

            <Box overflow='auto' maxWidth={maxWidthMain}>
              <CommoditiesCovered />
            </Box>
            <Box overflow='auto' maxWidth={maxWidthMain}>
              <Accounting />
            </Box>
          </Box>
        </Box>
      ) : (
        <DeprecatedComplianceTab />
      )}
    </div>
  )
}
